// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes circular-animation-8b85b72c{to{stroke-dashoffset:0}}.wrapper[data-v-8b85b72c]{background:#fff;border-radius:25px;display:flex;height:40px;justify-content:center;width:40px}.wrapper img[data-v-8b85b72c]{height:auto;-o-object-fit:contain;object-fit:contain;width:60%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
